import { render, staticRenderFns } from "./PiattaPasto.vue?vue&type=template&id=10810fa0&scoped=true"
import script from "./PiattaPasto.vue?vue&type=script&lang=js"
export * from "./PiattaPasto.vue?vue&type=script&lang=js"
import style0 from "./PiattaPasto.vue?vue&type=style&index=0&id=10810fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10810fa0",
  null
  
)

export default component.exports